import { useQuery } from "react-query"
import { DataSuccessService } from "../api/dataSuccess"

export const useDataSuccess = (userId?: string, options?: string) => {

    return useQuery({ queryKey: ['data_success', userId, options], queryFn: () => DataSuccessService.getRepports(userId,options), enabled: Boolean(userId) })

}